import { useCallback } from "react";
import { useProjectDataStore } from "stores/projectStore";
import { getProjectId } from "utils";

export const useChangeProject = () => {
  const setProjectId = useProjectDataStore((state) => state.setProjectId);
  const projectId = useProjectDataStore((state) => state.projectId);

  const changeProject = useCallback(
    (id: string | null) => {
      const projectIdUrlParam = getProjectId();
      if (id !== projectId || id !== projectIdUrlParam) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("projectId", id ?? "");
        window.history.pushState({}, "", currentUrl);
        setProjectId(id);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setProjectId],
  );

  return changeProject;
};
